export const gitVersion = 'main-1.0.13-439-g3fbf9785';
